function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _ = require('lodash');

var realMod = function realMod(value, mod) {
  return value % mod + (value >= 0 ? 0 : mod);
};

var HEX_RGX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
var SHORT_HEX_RGX = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
var RGB_RGX = /rgba?\((.*?)\)/i;

var fixShortHexIfNeeded = function fixShortHexIfNeeded(hex) {
  return hex.replace(SHORT_HEX_RGX, '#$1$1$2$2$3$3');
};

var hexToInt = function hexToInt(hex) {
  return parseInt(hex, 16);
};

var intToHex = function intToHex(n) {
  return (n < 16 ? '0' : '') + n.toString(16).toUpperCase();
};

var hexToRgb = function hexToRgb(hex) {
  return _(['red', 'green', 'blue']).zipObject(HEX_RGX.exec(fixShortHexIfNeeded(hex)).slice(1)).mapValues(hexToInt).value();
};

var isHexString = function isHexString(str) {
  return HEX_RGX.test(str) || SHORT_HEX_RGX.test(str);
};

var isRgbString = function isRgbString(str) {
  return RGB_RGX.test(str);
};

function parseRgbString(value) {
  var matches = RGB_RGX.exec(value);

  if (!matches) {
    throw new Error('Failed to parse rgb string');
  }

  var values = matches[1];

  var _values$split$map = values.split(',').map(function (x) {
    return Number(x.trim());
  }),
      _values$split$map2 = _slicedToArray(_values$split$map, 4),
      red = _values$split$map2[0],
      green = _values$split$map2[1],
      blue = _values$split$map2[2],
      alpha = _values$split$map2[3];

  return {
    red: red,
    green: green,
    blue: blue,
    alpha: alpha
  };
}

function applyOpacity(rgb, opacity) {
  return {
    red: (1 - opacity) * 255 + opacity * rgb.red,
    green: (1 - opacity) * 255 + opacity * rgb.green,
    blue: (1 - opacity) * 255 + opacity * rgb.blue
  };
}

var hexToRgbaCss = function hexToRgbaCss(hex, alpha) {
  var rgb = hexToRgb(hex);
  return 'rgba(' + rgb.red + ',' + rgb.green + ',' + rgb.blue + ',' + alpha + ')';
};

var getHue = function getHue(_ref) {
  var r = _ref.r,
      g = _ref.g,
      b = _ref.b,
      delta = _ref.delta,
      max = _ref.max;

  if (delta === 0) {
    return 0;
  }

  switch (max) {
    case r:
      return 60 * realMod((g - b) / delta, 6);

    case g:
      return 60 * ((b - r) / delta + 2);

    case b:
      return 60 * ((r - g) / delta + 4);
  }
};

var rgbToHsb = function rgbToHsb(rgb) {
  var _$mapValues = _.mapValues(rgb, function (v) {
    return v / 255;
  }),
      r = _$mapValues.red,
      g = _$mapValues.green,
      b = _$mapValues.blue;

  var max = Math.max(r, g, b);
  var delta = max - Math.min(r, g, b);
  var hue = getHue({
    r: r,
    g: g,
    b: b,
    delta: delta,
    max: max
  });
  var saturation = 100 * (max && delta / max);
  var brightness = 100 * max;
  return _.mapValues({
    hue: hue,
    saturation: saturation,
    brightness: brightness
  }, Math.round);
};

var hsbToRgb = function hsbToRgb(hsb) {
  var hue = hsb.hue,
      saturation = hsb.saturation,
      brightness = hsb.brightness;
  var h = realMod(hue, 360) / 360 * 6;
  var s = saturation / 100;
  var b = brightness / 100;
  var i = Math.floor(h);
  var f = h - i;
  var p = b * (1 - s);
  var q = b * (1 - f * s);
  var t = b * (1 - (1 - f) * s);
  var mod = i % 6;
  var red = [b, q, p, p, t, b][mod];
  var green = [t, b, b, q, p, p][mod];
  var blue = [p, p, t, b, b, q][mod];
  return _.mapValues({
    red: red,
    green: green,
    blue: blue
  }, function (v) {
    return Math.round(255 * v);
  });
};

var rgbToHex = function rgbToHex(rgb) {
  return '#' + [rgb.red, rgb.green, rgb.blue].map(intToHex).join('');
};

var hexToHsb = _.flow(hexToRgb, rgbToHsb);

var hsbToHex = _.flow(hsbToRgb, rgbToHex);

var getDistanceToWhite = function getDistanceToWhite(_ref2) {
  var saturation = _ref2.saturation,
      brightness = _ref2.brightness;
  return Math.sqrt(Math.pow(100 - brightness, 2) + Math.pow(saturation, 2));
};

var rgbTosRGB = function rgbTosRGB(color) {
  return color / 255;
};

var applyGammaCorrection = function applyGammaCorrection(sRGB) {
  if (sRGB <= 0.03928) {
    return sRGB / 12.92;
  }

  return Math.pow((sRGB + 0.055) / 1.055, 2.4);
};

var getLuminance = function getLuminance(rgb) {
  // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
  var RsRGB = rgbTosRGB(rgb.red);
  var GsRGB = rgbTosRGB(rgb.green);
  var BsRGB = rgbTosRGB(rgb.blue);
  var R = applyGammaCorrection(RsRGB);
  var G = applyGammaCorrection(GsRGB);
  var B = applyGammaCorrection(BsRGB);
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
};

module.exports = {
  isRgbString: isRgbString,
  isHexString: isHexString,
  rgbToHsb: rgbToHsb,
  hexToRgb: hexToRgb,
  hsbToRgb: hsbToRgb,
  rgbToHex: rgbToHex,
  hexToHsb: hexToHsb,
  hsbToHex: hsbToHex,
  getDistanceToWhite: getDistanceToWhite,
  hexToRgbaCss: hexToRgbaCss,
  parseRgbString: parseRgbString,
  applyOpacity: applyOpacity,
  getLuminance: getLuminance
};